export default "__VITE_ASSET__CS6M6bhn__"